export class MongoAtlasPrivateLinkEntry {
    'atlasProjectId';
    'cloudAccountId';
    'region';
    'serviceName';
    'vpcEndpointId';
    'vpcEndpointDns';
    'status';
    'updatedAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "atlasProjectId",
            "baseName": "atlasProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudAccountId",
            "baseName": "cloudAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceName",
            "baseName": "serviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcEndpointId",
            "baseName": "vpcEndpointId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcEndpointDns",
            "baseName": "vpcEndpointDns",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasPrivateLinkEntry.attributeTypeMap;
    }
    constructor() {
    }
}
